import React from 'react';
import { motion } from 'framer-motion';

interface Skill {
  name: string;
}

interface SkillCategory {
  title: string;
  skills: Skill[];
}

const skillCategories: SkillCategory[] = [
  { title: 'AI & Machine Learning', skills: [{ name: 'PyTorch' }, { name: 'Transformers' }, { name: 'Computer Vision' }, { name: 'LLMs' }] },
  { title: 'Data Science', skills: [{ name: 'Python' }, { name: 'SQL' }, { name: 'Pandas' }, { name: 'Statistics' }] },
  { title: 'Frontend Development', skills: [{ name: 'React' }, { name: 'TypeScript' }, { name: 'THREE.js' }, { name: 'Tailwind CSS' }, { name: 'WebGL' }] },
  { title: 'Creative Coding', skills: [{ name: 'p5.js' }, { name: 'Shaders (GLSL)' }, { name: 'Generative Art' }, { name: 'Framer Motion' }] },
  { title: 'Game Development', skills: [{ name: 'Game Physics' }, { name: 'Real-time Rendering' }, { name: 'Core Gameplay Design' }] },
  { title: 'Tools & Technologies', skills: [{ name: 'Git & GitHub' }, { name: 'Linux/Unix' }, { name: 'C' }, { name: 'Java' }] },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } },
};

const Skills: React.FC = () => {
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 max-w-6xl mx-auto"
    >
      {skillCategories.map((category) => (
        <motion.div key={category.title} variants={itemVariants}>
          <h3 className="font-display text-2xl font-semibold text-[var(--color-foreground)] border-b border-[var(--color-border)] pb-3 mb-5">{category.title}</h3>
          <ul className="space-y-3">
            {category.skills.map((skill) => (
              <li key={skill.name} className="text-md text-[var(--color-muted)]">{skill.name}</li>
            ))}
          </ul>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default Skills;